import { SxProps, Theme } from '@mui/material';

export const pendingBoxStyles: SxProps<Theme> = {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
};
